<form [formGroup]="firstFormGroup" autocomplete="off">
	<div ngClass.gt-md="container" ngClass.md="container" fxLayout="row" fxLayoutGap="20px">
		<div fxFlex.gt-md="75" fxFlex.lt-md>
			<div fxLayoutGap="2px" fxLayout="row" class="space " fxHide fxShow.gt-sm>
				<div class="backg padding-10 product-elevation" fxFlex="33.33">
					<div>
						<span class="font18px price-label">{{deliveryAddressLabel}}</span>
					</div>
					<div fxLayout="column" fxLayout.gt-sm="row" fxLayoutAlign="start center"
						fxLayoutAlign.gt-sm="space-between">
						<div fxLayout="row">
							<p class="fontStyle marginStyle">
								<span
									class="price-label font18px">{{firstFormGroup.value.salesFlatOrderAddress[0].firstName}}
									{{firstFormGroup.value.salesFlatOrderAddress[0].lastName}}</span><br>
								<span
									class="fontStyle price-label"><span>{{firstFormGroup.value.salesFlatOrderAddress[0].street}}</span><br />

									<span
										class="price-label"><span>{{firstFormGroup.value.salesFlatOrderAddress[0].city}}</span>
										{{firstFormGroup.value.salesFlatOrderAddress[0].postCode}}</span><br>
									<span
										class="price-label">{{firstFormGroup.value.salesFlatOrderAddress[0].region}}</span><br>
									<span
										class="price-label">{{firstFormGroup.value.salesFlatOrderAddress[0].state}}</span><br>
									<span class="price-label"><span>Phone Number :</span>
										{{firstFormGroup.value.salesFlatOrderAddress[0].telephone}}</span>
								</span>
							</p>
						</div>
					</div>
				</div>
				<div class="backg padding-10 product-elevation" fxFlex="33.33">
					<div class="marginTB20" fxLayoutAlign="center center">
						<span class="font18px"> <b> Order Status </b>&#58; <span
								class="success">{{firstFormGroup.controls.newStatus.value }}</span>
						</span>
					</div>
				</div>
				<div class="backg padding-10 product-elevation" fxFlex="33.33">
					<div>
						<span class="font18px">More Action</span>
					</div>
					<div fxLayout="row" fxLayout="row" fxLayoutAlign="space-between center">

						<div class="padding-td10" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px"><i
								color="warn" class="pdf material-icons">
								receipt
							</i> <span> Download Invoice</span></div>
						<button (click)="invoiceDownload()" style="color:white" class="primary"
							mat-stroked-button>Download</button>
					</div>
					<div *ngIf="cancelEnabled==1">
						<div *ngIf="(
					firstFormGroup.value.status == 'Pending'||firstFormGroup.value.status == 'Processing')" fxLayout="row"
							fxLayout="row" fxLayoutAlign="space-between center">

							<div class="padding-td10" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px"><i
									color="warn" class="pdf material-icons">
									cancel
								</i> <span> Cancel Order</span></div>
							<button (click)="cancelOrder()" style="color:white" class="primary"
								mat-stroked-button>Cancel Order</button>
						</div>
					</div>
				</div>
			</div>

			<div  *ngIf="firstFormGroup.value.salesFlatShipment?.length>0" class="backg padding-10 product-elevation marginSpace ">

				<div class="padding-10">

				<div class="tech"> 
					<span>
						{{otpText}}
					</span>
				</div>
				<div *ngIf="otpShowType==1" fxLayout="column" fxLayout.gt-sm="row">
					<div *ngIf="firstFormGroup.value.salesFlatShipment[0].startOtp!=null">
						<span><b>Start OTP</b>&#58; <span
								class="success">{{firstFormGroup.value.salesFlatShipment[0].startOtp}}</span></span>
					</div>
				</div>
				<div fxLayout="column" fxLayout.gt-sm="row">
					<div *ngIf="firstFormGroup.value.salesFlatShipment[0].endOtp!=null">
						<span><b>End OTP</b>&#58; <span
								class="success">{{firstFormGroup.value.salesFlatShipment[0].endOtp}}</span></span>
					</div>
				</div>

				</div>
			</div>

			<div class="padding-10" fxHide fxShow.gt-sm>

			</div>
			<div class="back">
				<div ngClass.gt-sm="border">
					<div class="bdr-b backgray padding-10 pointer-none" fxLayout="row"
						fxLayoutAlign="space-between center">
						<div class="order padding-5 pointer-none" style="cursor: not-allowed;">
							<span class="pointer-none">ORDER ID -
								<b>{{firstFormGroup.controls.extOrderId.value|uppercase}}</b> </span>
						</div>
					</div>
					<div class="backg borderb"
						*ngFor="let orderInfo of firstFormGroup.get('salesFlatOrderItem')['controls']; let i = index">

						<div ngClass.gt-sm="padding-10" class="bg-color " fxLayout="row" fxLayout.lt-sm="row-reverse"
							fxLayout.lt-sm="row-reverse" fxLayoutGap.lt-sm="10px">
							<div fxFlex="15" fxFlex.lt-sm="30" (click)="productShow(orderInfo)" class="pointer"
								fxLayoutAlign="center center">
								<img height="100" [src]="orderInfo.controls.image.value"
									onerror="this.src='assets/images/products/noImage/no-image.png';"
									[alt]="orderInfo.controls.name.value">
							</div>
							<div fxLayout="row" fxFlex.lt-sm fxFlex.gt-sm="60">
								<div class="padding-l10" fxLayout="column">
									<b class="pointer wrap"
										(click)="productShow(orderInfo)">{{orderInfo.controls.name.value}}</b>

									<div fxLayout="row" fxLayoutGap="3px">
										<span class="price-label">Qty: </span>
										<span class="price-label"> {{orderInfo.controls.qty.value}} </span>
									</div>
									<div fxLayout="row" fxLayoutGap="3px"
										*ngIf="orderInfo.controls.basePrice.value >orderInfo.controls.price.value">
										<span class="price-label">Base Price:</span>

										<span
											[ngClass]="orderInfo.controls.basePrice.value >orderInfo.controls.price.value?'price-label':'none'">{{
											orderInfo.controls.basePrice.value | currencyConvert}}
										</span>
									</div>

									<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="3px">
										<span class="price-label">Price:</span>

										<span class="price-label"> {{orderInfo.controls.price.value |
											currencyConvert}}</span>
										<span class="success"
											*ngIf="orderInfo.controls.basePrice.value >orderInfo.controls.price.value">&nbsp;{{orderInfo.controls.discountPercent.value
											| number : '1.2-2'}} %
											Off</span>
									</div>

									<div fxLayout="row" fxLayoutGap="3px">
										<span class="price-label">Discount Amount: </span>
										<!-- <span class="price-label">	{{orderInfo.controls.discountAmount.value}} </span> -->
										<span class="price-label"> {{orderInfo.controls.discountAmount.value}} </span>
									</div>
									<span class="price-label">Sub Total:<b class="faliure">

											{{orderInfo.controls.rowTotal.value | currencyConvert}}</b></span>

									<span class="price-label">Row Total:<b class="faliure">

											{{orderInfo.controls.rowTotal.value-orderInfo.controls.discountAmount.value
											| currencyConvert}}</b></span>
									<span class="price-label">Ordered On:{{firstFormGroup.controls.createdDate.value |
										date}}</span>
									<span class="price-label"
										*ngIf="firstFormGroup.controls.couponCode.value!=null">Coupon Code Applied:

										{{firstFormGroup.controls.couponCode.value}}</span>
									<div fxLayout="row">
										<span class="price-label">Order Status:</span>
										<!-- Order Status  -->
										<span class="success"
											*ngIf="firstFormGroup.controls.status.value=='Pending' || firstFormGroup.controls.status.value=='Processing'">
											{{firstFormGroup.controls.status.value.trim()}}
										</span>

										<span class="success" *ngIf="firstFormGroup.controls.status.value=='On Hold'">
											{{firstFormGroup.controls.status.value}}
										</span>
										<!-- invoiced -->
										<span class="success " *ngIf="firstFormGroup.value.status=='Invoiced'">
											{{orderInfo.controls.qty.value==orderInfo.controls.qtyCancelled.value ?
											'Cancelled':
											orderInfo.controls.qtyCancelled.value>0 ? 'Partially' :
											orderInfo.controls.qtyInvoiced.value== orderInfo.controls.qtyRefunded.value
											? 'Refunded' :
											orderInfo.controls.qtyRefunded.value>0?'Partially'
											:orderInfo.controls.qty.value== orderInfo.controls.qtyInvoiced.value ?
											'Invoiced'
											: orderInfo.controls.qtyInvoiced.value==0 ? 'Cancelled' : 'Partially ' }}
										</span>
										<!-- Partially Shipped -->
										<span class="success"
											*ngIf="firstFormGroup.controls.status.value=='Partially Shipped'">
											{{ orderInfo.controls.qty.value==orderInfo.controls.qtyCancelled.value ?
											'Cancelled':
											orderInfo.controls.qtyCancelled.value>0 ? 'Partially'
											:orderInfo.controls.qtyInvoiced.value==
											orderInfo.controls.qtyRefunded.value ? 'Refunded':
											orderInfo.controls.qtyRefunded.value>0?'Partially':orderInfo.controls.qtyInvoiced.value==
											orderInfo.controls.qtyShipped.value ? 'Shipped' :
											orderInfo.controls.qtyShipped.value==0 ? 'Not Yet Dispatched' : 'Partially
											'}}
										</span>
										<!-- Cancelled -->
										<span class="success" *ngIf="firstFormGroup.controls.status.value=='Cancelled'">
											{{firstFormGroup.controls.status.value}}
										</span>
										<!-- Completed -->
										<span class="success" *ngIf="firstFormGroup.controls.status.value=='Completed'">
											{{ orderInfo.controls.qty.value==orderInfo.controls.qtyCancelled.value ?
											'Cancelled':
											orderInfo.controls.qtyCancelled.value>0 ? 'Partially' :
											orderInfo.controls.qtyInvoiced.value== orderInfo.controls.qtyRefunded.value
											? 'Refunded' :
											orderInfo.controls.qtyRefunded.value==0 ? 'Completed' : 'Partially ' }}
										</span>
										<!-- Closed -->
										<span class="success" *ngIf="firstFormGroup.controls.status.value=='Closed'">
											{{firstFormGroup.controls.status.value}}
										</span>
										<!--  -->
									</div>
								</div>
							</div>
							<ng-container *ngIf="!authourized">
								<div fxLayout="row" fxLayoutAlign="end center">
									<div fxShow.gt-sm fxLayout="column" fxLayoutGap="10px">
										<div class="pointer padding-r20"
											*ngIf="firstFormGroup.controls.status.value=='Completed'&&orderInfo.controls.qty.value>orderInfo.controls.qtyCancelled.value "
											fxHide fxShow.gt-sm (click)="review(orderInfo)" fxLayout.gt-sm="row"
											fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
											<mat-icon class="primary-icon">star</mat-icon>
											<span class="font-primary-color">RATE & REVIEW PRODUCT</span>
										</div>
										<div (click)="trackEachStatus( orderInfo.controls.productId.value,orderInfo.value)"
											class="pointer padding-r20" fxHide fxShow.gt-sm fxLayout="row"
											fxLayoutAlign="start center" fxLayoutGap="10px">
											<mat-icon class="primary-icon">location_on</mat-icon>
											<span class="font-primary-color">Track</span>
										</div>

										<!-- <div 
										class="pointer padding-r20" fxHide fxShow.gt-sm fxLayout="row"
										fxLayoutAlign="start center" fxLayoutGap="10px">										
										<span class="font-primary-color">Cancel Order</span>
									    </div> -->

										<!-- <div class="pointer padding-r20" fxHide fxShow.gt-sm fxLayout="row"
											fxLayoutAlign="start center" fxLayoutGap="10px">
											<mat-icon color="primary">settings_backup_restore</mat-icon>
											<span class="font-primary-color">Return</span>
										</div>
										<div class="pointer padding-r20" fxHide fxShow.gt-sm fxLayout="row"
											fxLayoutAlign="start center" fxLayoutGap="10px">
											<mat-icon color="primary">live_help</mat-icon>
											<span class="font-primary-color">Help</span>
										</div> -->
									</div>
								</div>

							</ng-container>
						</div>



						<!-- <div fxHide fxShow.lt-sm class="bordert " fxLayout="row">
								<div fxFlex="50" class="padding-10 bg-color" fxLayout="row"
									fxLayoutAlign="center center" fxLayoutGap="5px">
									<mat-icon color="primary">settings_backup_restore</mat-icon>
									<span class="font-primary-color">Return</span>
								</div>
								<div fxFlex="50" class="padding-10 borderl bg-color" fxLayout="row"
									fxLayoutAlign="center center" fxLayoutGap="5px">
									<mat-icon color="primary">live_help</mat-icon>
									<span class="font-primary-color">Help</span>
								</div>
							</div>
							<div fxHide fxShow.lt-sm class="borderdark">
							</div> -->
						<ng-container *ngIf="!authourized">


							<div *ngIf="firstFormGroup.controls.status.value=='Completed'&&orderInfo.controls.qty.value>orderInfo.controls.qtyCancelled.value "
								fxHide.md fxHide.lg fxHide.xl class="p-1 or bordert bg-color" fxLayout="row"
								fxLayoutAlign="center center">
								<div (click)="review(orderInfo.controls.productId.value)" fxLayout="row"
									fxLayoutAlign="start center" fxLayoutGap="10px">
									<mat-icon class="primary-icon">star</mat-icon>
									<span class="font-primary-color">RATE & REVIEW </span>
								</div>


							</div>

							<div fxHide.md fxHide.lg fxHide.xl class="p-1 or bordert bg-color" fxLayout="row"
								fxLayoutAlign="center center">
								<div (click)="trackEachStatus( orderInfo.controls.productId.value,orderInfo.value)"
									fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
									<mat-icon class="primary-icon">location_on</mat-icon>
									<span class="font-primary-color">Track</span>
								</div>


							</div>
						</ng-container>
						<div fxHide.gt-sm class="borderdark">
						</div>

					</div>
					<div (click)="invoiceDownload()" fxHide.gt-sm class="padding-10 bg-color" fxLayout="row"
						fxLayoutAlign="space-between center">
						<span class="price-label">DOWNLOAD INVOICE</span>
						<mat-icon>chevron_right</mat-icon>
					</div>

					<div fxHide.gt-sm class="borderdark">


					</div>
					<div *ngIf="cancelEnabled==1">
						<div *ngIf="(
						firstFormGroup.value.status == 'Pending'||firstFormGroup.value.status == 'Processing')">

							<div (click)="cancelOrder()" fxHide.gt-sm class="padding-10 bg-color" fxLayout="row"
								fxLayoutAlign="space-between center">
								<span class="price-label">CANCEL ORDER</span>
								<mat-icon>chevron_right</mat-icon>
							</div>

						</div>
					</div>

					<div fxHide.gt-sm class="borderdark">


					</div>
					<div fxHide.gt-sm>
						<div class="padding-10 bg-color borderb">
							<span class="price-label">{{deliveryAddressLabel}}</span>
						</div>
						<div class="padding-10 backg " fxLayout="column">
							<span
								class="font18px">{{firstFormGroup.value.salesFlatOrderAddress[0].firstName}}{{firstFormGroup.value.salesFlatOrderAddress[0].lastName}}</span>
							<div fxLayout="row">
								<span
									class="price-label">{{firstFormGroup.value.salesFlatOrderAddress[0].company}}</span>
								<span class="price-label">{{firstFormGroup.value.salesFlatOrderAddress[0].street}}
								</span>

							</div>
							<span
								class="price-label"><span>{{firstFormGroup.value.salesFlatOrderAddress[0].city}}</span>
								{{firstFormGroup.value.salesFlatOrderAddress[0].postCode}}</span>

							<span class="price-label">{{firstFormGroup.value.salesFlatOrderAddress[0].region}}</span>
							<span class="price-label"><span>Phone Number :</span>
								{{firstFormGroup.value.salesFlatOrderAddress[0].telephone}}</span>
						</div>
					</div>
					<div fxHide fxShow.lt-sm class="borderdark">
					</div>
					<div fxHide.gt-sm class=" product-elevation">
						<!-- <div class="padding-10 bg-color borderb">
							<span class="price-label">PRICE DETAILS</span>
						</div> -->
						<!-- <div class="padding-10" fxLayout="row" class="backg">
							<div class="padding-l10" fxLayout="column" fxFlex="50" fxLayoutGap="5px">
								<span class="price-label">Item Count</span>
								<span class="price-label">Subtotal</span>
								<span class="price-label">Shipping Amount</span>
								<span class="price-label">Cod Charge</span>
								<span class="price-label">Discount Amount</span>
								<span class="price-label">Total</span>
							</div>
							<div fxLayout="column" class="padding-r10" fxFlex="50" fxLayoutAlign="center end"
								fxLayoutGap="5px">
								<span class="price-label">{{firstFormGroup.value.itemsCount}}</span>
								<span class="price-label">{{firstFormGroup.value.subtotal |currencyConvert }}</span>
								<span class="price-label">
										{{firstFormGroup.value.shippingAmount == null ? 0.0 :
									firstFormGroup.value.shippingAmount | currencyConvert}}</span>

                <span class="price-label">&nbsp; {{firstFormGroup.value.discountAmount | currencyConvert}}</span>
								<span class="price-label">&nbsp; {{firstFormGroup.value.grandTotal | currencyConvert}}</span>
								
							</div>
						</div> -->
						<div class="price backg">
							<div class="head borderb padding-160">
								<span class="font-16px blackColor price-label padding-l15">PRICE DETAILS</span>
							</div>

							<div *ngIf="priceDetailType==0">
								<div fxLayout="row" class="priceDetail padding-l10 padding-t5 border-btm">
									<div fxFlex="65" fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="10px">
										<span class="price-label">Item Count</span>
										<span class="price-label">Subtotal</span>
										<span *ngIf="showGst==1" class="price-label">{{taxName}}</span>
										<span class="price-label">Shipping Amount</span>
										<span *ngIf="firstFormGroup.value.status != 'Processing'"
											class="price-label">{{additionalPaymentText}}</span>
										<span class="price-label">Discount Amount</span>
										<span class="price-label"
											*ngIf="firstFormGroup.value.additionalMedicalharge>0">Consultation
											Fees</span>
									</div>
									<div fxFlex="35" fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="10px">
										<span class="price-label">{{firstFormGroup.value.itemsCount}}</span>
										<span class="price-label" *ngIf="showGst==0">{{firstFormGroup.value.subtotal
											|currencyConvert }}</span>
										<span class="price-label"
											*ngIf="showGst==1">{{firstFormGroup.value.subtotal-firstFormGroup.value.taxAmount
											|currencyConvert }}</span>
										<span class="price-label" *ngIf="showGst==1">{{firstFormGroup.value.taxAmount
											|currencyConvert }}</span>
										<span class="price-label" *ngIf="firstFormGroup.value.shippingAmount == null">
											{{
											0.0 |currencyConvert}}</span>
										<span class="price-label" *ngIf="firstFormGroup.value.shippingAmount != null">
											{{
											firstFormGroup.value.shippingAmount|currencyConvert}}</span>
										<!-- <span  *ngIf="firstFormGroup.value.status != 'Processing'" class="price-label wordbk">{{codPaymentCharge |currencyConvert }}</span> -->

										<span class="price-label"
											*ngIf="firstFormGroup.value.codCharges == null && firstFormGroup.value.status != 'Processing'">
											{{ 0.0
											|currencyConvert}}</span>
										<span class="price-label"
											*ngIf="firstFormGroup.value.codCharges != null && firstFormGroup.value.status != 'Processing'">
											{{
											firstFormGroup.value.codCharges|currencyConvert}}</span>

										<span class="price-label padding-b5"> {{firstFormGroup.value.discountAmount ==
											null
											? 0.0 :
											firstFormGroup.value.discountAmount |currencyConvert }}</span>
										<span class="price-label padding-b5"
											*ngIf="firstFormGroup.value.additionalMedicalharge>0">
											{{ firstFormGroup.value.additionalMedicalharge |currencyConvert }}</span>
									</div>
								</div>

								<ng-container *ngIf="firstFormGroup.value.partialPaid==1">


									<div fxLayout="row" class="priceDetail padding-tb10 padding-l10 "
										fxLayoutAlign="space-between center">
										<div fxFlex="65" fxLayout="column" fxLayoutAlign="center start"
											fxLayoutGap="10px">
											<span class="price-label">Partial Paid Amount</span>

										</div>
										<div fxFlex="35" fxLayout="column" fxLayoutAlign="center start"
											fxLayoutGap="10px">
											<span class="price-label">{{firstFormGroup.value.partialPaidAmount
												|currencyConvert }}</span>

										</div>
									</div>



									<div *ngIf="firstFormGroup.value.partialPaid>0" fxLayout="row"
										class="priceDetail padding-tb10 padding-l10 "
										fxLayoutAlign="space-between center">
										<div fxFlex="65" fxLayout="column" fxLayoutAlign="center start"
											fxLayoutGap="10px">
											<span class="price-label">Pending Amount</span>

										</div>
										<div fxFlex="35" *ngIf="firstFormGroup.value.partialPaid==1" fxLayout="column"
											fxLayoutAlign="center start" fxLayoutGap="10px">
											<span class="price-label">{{firstFormGroup.value.remainingBalance
												|currencyConvert }}</span>

										</div>
									</div>

								</ng-container>

								<div fxLayout="row" class="priceDetail padding-tb10 padding-l10 "
									fxLayoutAlign="space-between center">
									<div fxFlex="65" fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="10px">
										<span class="price-label">Grand Total</span>

									</div>
									<div fxFlex="35" fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="10px">
										<span class="price-label">{{firstFormGroup.value.grandTotal+
											firstFormGroup.value.codCharges |currencyConvert }}</span>

									</div>
								</div>
							</div>

							<div *ngIf="priceDetailType==1">
								<div fxLayout="row" class="priceDetail padding-l10 padding-t5 border-btm">
									<div fxFlex="65" fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="10px">
										<span class="price-label">Item Count</span>
										<span class="price-label">Total MRP</span>
										<span class="price-label">Discount on MRP</span>
										<span class="price-label">Shipping & Convenience Fee</span>
										<span class="price-label"
											*ngIf="firstFormGroup.value.additionalMedicalharge>0">Consultation
											Fees</span>
									</div>
									<div fxFlex="35" fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="10px">
										<span class="price-label">{{firstFormGroup.value.itemsCount}}</span>
										<span class="price-label">{{firstFormGroup.value.baseGrandTotal
											|currencyConvert }}</span>
										<span
											class="price-label">{{firstFormGroup.value.baseGrandTotal-firstFormGroup.value.subtotal
											|currencyConvert }}</span>
										<span class="price-label" *ngIf="firstFormGroup.value.shippingAmount == null">
											{{
											0.0 |currencyConvert}}</span>
										<span class="price-label" *ngIf="firstFormGroup.value.shippingAmount != null">
											{{
											firstFormGroup.value.shippingAmount|currencyConvert}}</span>
										<span class="price-label padding-b5"
											*ngIf="firstFormGroup.value.additionalMedicalharge>0">
											{{ firstFormGroup.value.additionalMedicalharge |currencyConvert }}</span>
									</div>
								</div>

								<ng-container *ngIf="firstFormGroup.value.partialPaid==1">
									<div fxLayout="row" class="priceDetail padding-tb10 padding-l10 "
										fxLayoutAlign="space-between center">
										<div fxFlex="65" fxLayout="column" fxLayoutAlign="center start"
											fxLayoutGap="10px">
											<span class="price-label">Partial Paid Amount</span>

										</div>
										<div fxFlex="35" fxLayout="column" fxLayoutAlign="center start"
											fxLayoutGap="10px">
											<span class="price-label">{{firstFormGroup.value.partialPaidAmount
												|currencyConvert }}</span>

										</div>
									</div>



									<div *ngIf="firstFormGroup.value.partialPaid>0" fxLayout="row"
										class="priceDetail padding-tb10 padding-l10 "
										fxLayoutAlign="space-between center">
										<div fxFlex="65" fxLayout="column" fxLayoutAlign="center start"
											fxLayoutGap="10px">
											<span class="price-label">Pending Amount</span>

										</div>
										<div fxFlex="35" *ngIf="firstFormGroup.value.partialPaid==1" fxLayout="column"
											fxLayoutAlign="center start" fxLayoutGap="10px">
											<span class="price-label">{{firstFormGroup.value.remainingBalance
												|currencyConvert }}</span>

										</div>
									</div>

								</ng-container>

								<div fxLayout="row" class="priceDetail padding-tb10 padding-l10 "
									fxLayoutAlign="space-between center">
									<div fxFlex="65" fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="10px">
										<span class="price-label">Amount Payable</span>

									</div>
									<div fxFlex="35" fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="10px">
										<span class="price-label">{{firstFormGroup.value.baseGrandTotal+
											firstFormGroup.value.codCharges |currencyConvert }}</span>

									</div>
								</div>

								<div fxLayout="row" class="priceDetail padding-tb10 padding-l10 "
									fxLayoutAlign="space-between center">
									<div fxFlex="65" fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="10px">
										<span class="price-label">Total Savings</span>

									</div>
									<div fxFlex="35" fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="10px">
										<span
											class="price-label">{{firstFormGroup.value.baseGrandTotal-firstFormGroup.value.subtotal|currencyConvert
											}}</span>

									</div>
								</div>
							</div>

						</div>

					</div>

				</div>

			</div>
		</div>
		<div fxHide fxShow.gt-sm fxFlex.gt-sm="0" fxFlex="25">
			<div class="price backg">
				<div class="head borderb padding-160">
					<span class="font-16px blackColor price-label padding-l15">PRICE DETAILS</span>
				</div>
				<div *ngIf="priceDetailType==0">
					<div fxLayout="row" class="priceDetail padding-l10 padding-t5 border-btm">
						<div fxFlex="65" fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="10px">
							<span class="price-label">Item Count</span>
							<span class="price-label">Subtotal</span>
							<span class="price-label" *ngIf="showGst==1">{{taxName}}</span>
							<span class="price-label">Shipping Amount</span>
							<span *ngIf="firstFormGroup.value.status != 'Processing'"
								class="price-label">{{additionalPaymentText}}</span>
							<span class="price-label">Discount Amount</span>
							<span class="price-label" *ngIf="firstFormGroup.value.additionalMedicalharge>0">Consultation
								Fees</span>
							<span class="price-label" *ngIf="firstFormGroup.value.partialPaid>0">Partial Paid
								Amount</span>
							<span class="price-label" *ngIf="firstFormGroup.value.partialPaid>0">Pending Amount</span>
						</div>
						<div fxFlex="35" fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="10px">
							<span class="price-label">{{firstFormGroup.value.itemsCount}}</span>
							<span class="price-label" *ngIf="showGst==0">{{firstFormGroup.value.subtotal
								|currencyConvert
								}}</span>
							<span class="price-label"
								*ngIf="showGst==1">{{firstFormGroup.value.subtotal-firstFormGroup.value.taxAmount
								|currencyConvert }}</span>
							<span class="price-label" *ngIf="showGst==1">{{firstFormGroup.value.taxAmount
								|currencyConvert
								}}</span>
							<span class="price-label" *ngIf="firstFormGroup.value.shippingAmount == null"> {{ 0.0
								|currencyConvert}}</span>
							<span class="price-label" *ngIf="firstFormGroup.value.shippingAmount != null"> {{
								firstFormGroup.value.shippingAmount|currencyConvert}}</span>
							<!-- <span *ngIf="firstFormGroup.value.status != 'Processing'" class="price-label wordbk">{{codPaymentCharge |currencyConvert }}</span> -->

							<span class="price-label"
								*ngIf="firstFormGroup.value.codCharges == null && firstFormGroup.value.status != 'Processing'">
								{{ 0.0
								|currencyConvert}}</span>
							<span class="price-label"
								*ngIf="firstFormGroup.value.codCharges != null && firstFormGroup.value.status != 'Processing'">
								{{
								firstFormGroup.value.codCharges|currencyConvert}}</span>

							<span class="price-label padding-b5"> {{firstFormGroup.value.discountAmount == null ? 0.0 :
								firstFormGroup.value.discountAmount |currencyConvert }}</span>
							<!-- <span class="price-label padding-b5" *ngIf="firstFormGroup.value.additionalMedicalharge>0"> 
						{{ firstFormGroup.value.additionalMedicalharge |currencyConvert }}</span> -->

							<span class="price-label padding-b5" *ngIf="firstFormGroup.value.additionalMedicalharge>0">
								{{ firstFormGroup.value.additionalMedicalharge |currencyConvert }}</span>

							<span class="price-label padding-b5" *ngIf="firstFormGroup.value.partialPaid==1">
								{{firstFormGroup.value.partialPaidAmount |currencyConvert }}</span>

							<span class="price-label padding-b5" *ngIf="firstFormGroup.value.partialPaid==1">
								{{firstFormGroup.value.remainingBalance |currencyConvert }}</span>

						</div>
					</div>


					<div fxLayout="row" class="priceDetail padding-tb10 padding-l10 "
						fxLayoutAlign="space-between center">
						<div fxFlex="65" fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="10px">
							<span class="price-label">Grand Total</span>

						</div>
						<div fxFlex="35" fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="10px">
							<span class="price-label">{{firstFormGroup.value.grandTotal +
								firstFormGroup.value.codCharges |currencyConvert }} </span>

						</div>
					</div>
				</div>

				<div *ngIf="priceDetailType==1">
					<div fxLayout="row" class="priceDetail padding-l10 padding-t5 border-btm">
						<div fxFlex="65" fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="10px">
							<span class="price-label">Item Count</span>
							<span class="price-label">Total MRP</span>
							<span class="price-label">Discount on MRP</span>
							<span class="price-label">Shipping & Convenience Fee</span>
							<span class="price-label" *ngIf="firstFormGroup.value.additionalMedicalharge>0">Consultation
								Fees</span>
							<span class="price-label" *ngIf="firstFormGroup.value.partialPaid>0">Partial Paid
								Amount</span>
							<span class="price-label" *ngIf="firstFormGroup.value.partialPaid>0">Pending Amount</span>
						</div>
						<div fxFlex="35" fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="10px">
							<span class="price-label">{{firstFormGroup.value.itemsCount}}</span>
							<span class="price-label">{{firstFormGroup.value.baseGrandTotal |currencyConvert
								}}</span>
							<span class="price-label"
								*ngIf="showGst==1">{{firstFormGroup.value.baseGrandTotal-firstFormGroup.value.subtotal
								|currencyConvert }}</span>
							<span class="price-label" *ngIf="firstFormGroup.value.shippingAmount == null"> {{ 0.0
								|currencyConvert}}</span>
							<span class="price-label" *ngIf="firstFormGroup.value.shippingAmount != null"> {{
								firstFormGroup.value.shippingAmount|currencyConvert}}</span>

							<span class="price-label padding-b5" *ngIf="firstFormGroup.value.additionalMedicalharge>0">
								{{ firstFormGroup.value.additionalMedicalharge |currencyConvert }}</span>

							<span class="price-label padding-b5" *ngIf="firstFormGroup.value.partialPaid==1">
								{{firstFormGroup.value.partialPaidAmount |currencyConvert }}</span>

							<span class="price-label padding-b5" *ngIf="firstFormGroup.value.partialPaid==1">
								{{firstFormGroup.value.remainingBalance |currencyConvert }}</span>

						</div>
					</div>


					<div fxLayout="row" class="priceDetail padding-tb10 padding-l10 "
						fxLayoutAlign="space-between center">
						<div fxFlex="65" fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="10px">
							<span class="price-label">Amount Payable</span>

						</div>
						<div fxFlex="35" fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="10px">
							<span class="price-label">{{firstFormGroup.value.grandTotal +
								firstFormGroup.value.codCharges |currencyConvert }} </span>

						</div>
					</div>

					<div fxLayout="row" class="priceDetail padding-tb10 padding-l10 "
						fxLayoutAlign="space-between center">
						<div fxFlex="65" fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="10px">
							<span class="price-label">Total Savings</span>

						</div>
						<div fxFlex="35" fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="10px">
							<span
								class="price-label">{{firstFormGroup.value.baseGrandTotal-firstFormGroup.value.subtotal
								|currencyConvert }} </span>

						</div>
					</div>
				</div>




			</div>
		</div>
	</div>
</form>

<ng-template #cancelOrderDialog>

	<div class="primary" fxLayout="row" fxLayoutAlign="end center">
		<button (click)="close()" mat-icon-button>
			<mat-icon style="color: white;">close</mat-icon>
		</button>
	</div>
	<div class="padding-10" fxLayout="column" fxLayoutGap="20px">
		<div fxLayout="row" fxLayoutAlign="start center">
			<span>Are you sure you want to cancel this order?</span>
		</div>
		<div fxLayoutAlign="end center" fxLayout="row" fxLayoutGap="10px">
			<button mat-raised-button (click)="close()">Cancel</button>

			<button style="color:white" class="primary" [disabled]="textCancel !='OK'" (click)="cancel()"
				mat-raised-button>
				{{textCancel}}
				<mat-icon *ngIf="textCancel !='OK' ">
					<mat-spinner class="primary" diameter="20">
					</mat-spinner>
				</mat-icon></button>
		</div>
	</div>

</ng-template>

<div fxHide fxShow.lt-sm class="p-T10">

</div>